/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Nov 2021
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import constants from '../../../../globalization';
import styles from './FindVoucher.module.css';
import PopupHeader from '../../../../components/PopupHeader';
import VoucherInput from './VoucherInput';

const FindVoucher = props => {
  const { onVoucherSearch, dismissPopup } = props;
  const [state, setState] = useState({
    first4Digit: '',
    last4Digit: '',
  });

  const handleInputChange = key => event => {
    const value = event.target.value;
    if (key) {
      setState((prevState) => {
        return {
          ...prevState,
          [key]: value,
        }
      });
    }
  };

  const findVoucherHandler = () => {
    onVoucherSearch && onVoucherSearch({ first: state.first4Digit, last: state.last4Digit });
  };

  return (
    <div className={styles.container}>
      <PopupHeader
        containerStyle={styles.headerStyle}
        title={constants.enterVoucherCode}
        titleStyle={styles.titleStyle}
        onClose={dismissPopup} />
      <VoucherInput
        first4Digit={state.first4Digit}
        last4Digit={state.last4Digit}
        handleInputChange={handleInputChange}
      />
      <Button
        className={styles.button}
        disabled={(state.first4Digit.trim().length < 4) || (state.last4Digit.trim().length < 4)}
        onClick={findVoucherHandler}>
        <span className={styles.btnText}>{constants.findVoucher}</span>
      </Button>
    </div>
  );
};

export default FindVoucher;

FindVoucher.propTypes = {
  onVoucherSearch: PropTypes.func.isRequired,
  dismissPopup: PropTypes.func.isRequired,
};

FindVoucher.defaultProps = {
  onVoucherSearch: () => { },
  dismissPopup: () => { },
};
